import React from 'react';
import '../styles/common.css';
import '../styles/typography.css';

import {FormattedMessage, useIntl} from 'react-intl';

import logo_fi_lvv from '../images/LVV_suomi_nega.svg';
import logo_sv_lvv from '../images/LVV_suomi-ruotsi_nega.svg';

const Footer = ({lvvEnabled}) => {
  const d = new Date();
  const currentYear = d.getFullYear();

  const intl = useIntl();
  const copyrightLink = intl.formatMessage({id: 'copyrightLink'});
  const contactInformationLink = intl.formatMessage({id: 'contactInformationLink'});
  const fillInApplicationLink = intl.formatMessage({id: 'fillInApplicationLink'});
  const readMoreAboutDebtCollectionLink = intl.formatMessage({id: 'readMoreAboutDebtCollectionLink'});
  const privacyPolicy = intl.formatMessage({id: 'privacyPolicyLink'});

  const oldFooter = () => {
    return (
      <footer className="footer">
        <p>
          <FormattedMessage id="footer-read_more_info" defaultMessage="Lue lisää " />
          {lvvEnabled ? (
            <a
              style={{textDecoration: 'underline'}}
              href={intl.locale === 'fi' ? 'lvv-placeholder' : 'lvv-placeholder'}
            >
              <FormattedMessage id="footer-read_more_info_lvv" defaultMessage="lvv-placeholder" />
            </a>
          ) : (
            <a
              style={{textDecoration: 'underline'}}
              href={
                intl.locale === 'fi'
                  ? 'https://avi.fi/asioi/yritys-tai-yhteiso/valvonta-ja-kantelut/raha-ja-omaisuus/rahanpesulain-valvonta'
                  : 'https://avi.fi/sv/valj-arende/foretag-eller-organisation/tillsyn-och-klagomal/pengar-och-formogenhet/lagen-om-penningtvatt'
              }
            >
              <FormattedMessage
                id="footer-read_more_info_avi"
                defaultMessage="aluehallintoviraston "
              />
            </a>
          )}
          <FormattedMessage id="footer-read_more_info_pages" defaultMessage="sivuilta " />|{' '}
          {lvvEnabled ? (
            <a style={{textDecoration: 'underline'}} href="lvv-placeholder">
              <FormattedMessage id="footer-data_protection" defaultMessage="Tietosuoja" />
            </a>
          ) : (
            <a style={{textDecoration: 'underline'}} href="http://www.avi.fi/web/avi/tietosuoja">
              <FormattedMessage id="footer-data_protection" defaultMessage="Tietosuoja" />
            </a>
          )}
          | <FormattedMessage id="footer-fill_application_info" defaultMessage="Täytä hakemus" />{' '}
          <a style={{textDecoration: 'underline'}} href="https://sahkoinenasiointi.ahtp.fi">
            <FormattedMessage id="footer-fill_application_info2" defaultMessage="täältä" />
          </a>
        </p>
        <p>
          © {currentYear}{' '}
          {lvvEnabled ? (
            <FormattedMessage id="general_lvv" defaultMessage="lvv-placeholder" />
          ) : (
            <FormattedMessage id="general_avi" defaultMessage="Aluehallintovirasto" />
          )}
        </p>
      </footer>
    );
  };

  const newFooter = () => {
    return (
      <footer style={{width: '100%'}}>
        <div style={{flexDirection: 'column'}}>
          <div
            style={{
              backgroundColor: 'var(--colors-keskivihrea, #358273)',
              display: 'flex',
              color: 'white',
              paddingTop: '24px',
              paddingLeft: '80px',
              gap: '64px'
            }}
            className="d-flex flex-column flex-md-row align-items-start"
          >
            <img
              className={`${intl.locale === 'fi' ? 'logo__fi' : 'logo__sv'} mb-md-0`}
              alt={'lvv-placeholder'}
              src={intl.locale === 'fi' ? logo_fi_lvv : logo_sv_lvv}
              style={{marginTop: '2rem'}}
            />

            <div style={{flexDirection: 'column'}} className="d-flex mb-4 mb-md-0">
              <p className="body-lg-bold" style={{color: 'white'}}>
                <FormattedMessage id="additionalInfoAndLinks" />
              </p>
              <p style={{overflowWrap: 'anywhere'}}>
                <a className="link-sm" href={readMoreAboutDebtCollectionLink}>
                  <FormattedMessage id="readMoreAboutDebtCollection1" />
                </a>
                {' '}
                <FormattedMessage id="readMoreAboutDebtCollection2" />
              </p>
              <p style={{overflowWrap: 'anywhere'}}>
                <a className="link-sm" href={fillInApplicationLink}>
                  <FormattedMessage id="fillInApplication1" />
                </a>
                {' '}
                <FormattedMessage id="fillInApplication2" />.
              </p>
              <p>
                <a className="link-sm" href={contactInformationLink}>
                  <FormattedMessage id="contactInformation" />
                </a>
              </p>
            </div>
          </div>

          <div
            style={{
              minHeight: '58px',
              backgroundColor: 'var(--colors-tummansininen, #00008e)',
              color: 'white'
            }}
          >
            <div
              style={{
                maxWidth: '460px',
                height: 'auto',
                margin: '0 auto',
                position: 'relative',
                display: 'flex',
                paddingTop: '16px'
              }}
              className="d-flex flex-column flex-md-row align-items-center"
            >
              <a className="link-sm mb-2 mb-md-0" href={privacyPolicy}>
                <FormattedMessage id="privacyPolicy" />
              </a>

              <p
                style={{marginLeft: '16px', marginRight: '16px'}}
                className="d-none d-md-block my-0"
              >
                |
              </p>

              <a className="link-sm mt-2 mt-md-0" href={copyrightLink}>
                <FormattedMessage id="copyright" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
  };

  return lvvEnabled ? newFooter() : oldFooter();
};

export default Footer;
